/**
 * Vuex "posts" module (registered under the `posts` namespace in the root store).
 *
 * Aggregates draft-post management and Bluesky account linking: state
 * (store.js), actions (operations.js), getters (selectors.js), and mutations
 * (updates.js).
 */
import state from "./store";
import mutations from "./updates";
import getters from "./selectors";
import actions from "./operations";

export default {
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations,
};
